document.addEventListener("DOMContentLoaded", function () {
  const config = {
    max_samples: 2, // Maximum number of samples a user can select
    bind_element: "sample-selection-placeholder",
  };

  const products = [
    {
      name: "Sample Candlenut Body Creme",
      image:
        "https://juara-skincare-nz.myshopify.com/cdn/shop/files/candlenutbodycreme-main.png?v=1716516950&width=100",
      description:
        "Immediate and long-lasting relief for even the driest skin with this rich, ultra-nourishing body moisturiser.",
      code: "code1",
    },
    {
      name: "Sample Candlenut Body Polish",
      image:
        "https://juara-skincare-nz.myshopify.com/cdn/shop/files/Aibodypolish-03.jpg?v=1694555389&width=1080",
      description:
        "A revelation for dry, dull, or rough skin texture. A dual action scrub that can be used in or out of the shower",
      code: "code2",
    },
    {
      name: "Travel Size Radiance Enzyme Scrub",
      image:
        "https://juara-skincare-nz.myshopify.com/cdn/shop/files/ScreenShot2023-12-13at10.15.00AM.png?v=1702415709&width=100",
      description:
        "Pores are visibly reduced, resulting in a smoother and more even skin texture.",
      code: "code3",
    },
  ];

  // Function to get selected samples from local storage
  function getSelectedSamples() {
    return JSON.parse(localStorage.getItem("selectedSamples")) || [];
  }

  // Function to update local storage
  function updateSelectedSamples(samples) {
    localStorage.setItem("selectedSamples", JSON.stringify(samples));
  }

  // Function to update the sample count display
  function updateSampleCountDisplay() {
    const selectedSamples = getSelectedSamples();
    const sampleCount = document.getElementById("sample-count");
    sampleCount.textContent = `${selectedSamples.length} of ${config.max_samples} selected`;
  }

  // Function to render the sample list in the modal
  function renderSampleList() {
    const sampleList = document.getElementById("sample-list");
    sampleList.innerHTML = "";

    products.forEach((product) => {
      const isSelected = getSelectedSamples().includes(product.code);
      const productElement = document.createElement("div");
      productElement.innerHTML = `
              <div>
                  
<span style="display: flex; align-items: center;">
  <img src="${product.image}" alt="${product.name}" width="50" style="margin-right: 10px;">
  <h3 style="font-size: 1.5rem; margin: 0;">${product.name}</h3>
</span>
                  
                  
                  <p>${product.description}</p>
                  <label>
                      <input type="checkbox" value="${product.code}" ${isSelected ? "checked" : ""}>
                      Select
                  </label>
              </div>
              <hr>
          `;
      sampleList.appendChild(productElement);
    });
  }

  // Function to handle sample selection
  function handleSampleSelection(event) {
    const selectedSamples = getSelectedSamples();
    const maxSamples = config.max_samples;
    const sampleCode = event.target.value;

    if (event.target.checked) {
      if (selectedSamples.length < maxSamples) {
        selectedSamples.push(sampleCode);
      } else {
        event.target.checked = false;
        alert(`You can only select up to ${maxSamples} samples.`);
      }
    } else {
      const index = selectedSamples.indexOf(sampleCode);
      if (index > -1) {
        selectedSamples.splice(index, 1);
      }
    }

    updateSelectedSamples(selectedSamples);
    updateSampleCountDisplay();
  }

  // Function to open the modal
  function openModal() {
    const modal = document.getElementById("sample-modal");
    modal.style.display = "block";
    renderSampleList();
    updateSampleCountDisplay();

    // Add event listeners to checkboxes
    document
      .querySelectorAll('#sample-list input[type="checkbox"]')
      .forEach((checkbox) => {
        checkbox.addEventListener("change", handleSampleSelection);
      });
  }

  // Function to close the modal
  function closeModal() {
    const modal = document.getElementById("sample-modal");
    modal.style.display = "none";
  }

  // Bind the "Select your free samples" button to the specified element
  const bindElement = document.getElementById(config.bind_element);
  bindElement.innerHTML = `
      <button id="open-sample-modal"><b>Select your two free samples</b></button>
      <p id="sample-count"></p><br>
  `;
  updateSampleCountDisplay();

  // Add event listener to open the modal
  document
    .getElementById("open-sample-modal")
    .addEventListener("click", openModal);

  // Add event listener to close the modal
  document.querySelector(".modal .close").addEventListener("click", closeModal);

  // Close the modal if the user clicks outside of the modal content
  window.addEventListener("click", function (event) {
    const modal = document.getElementById("sample-modal");
    if (event.target === modal) {
      closeModal();
    }
  });
});
